<template>
  <div
    class="container"
    :class="noFav?'noFav':''"
  >
    <div v-if="noFav">
      <span class="noFavLine">
        <img src="@/assets/web_icons/heart_red_filled.png">
        你未有心水樓盤呢，去住宅找尋你的心水樓盤吧
      </span>
    </div>
    <PropertyCardList v-bind:properties="list"></PropertyCardList>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import PropertyCardList from "@/components/PropertyCardList.vue";

const promiseSerial = funcs =>
  funcs.reduce(
    (promise, func) =>
      promise.then(result => func().then(Array.prototype.concat.bind(result))),
    Promise.resolve([])
  );

export default {
  name: "wishlist",
  components: {
    PropertyCardList
  },
  data() {
    return {
      list: [],
      noFav: false
    };
  },
  mounted() {
    const ids = this.getFav();
    const getProperty = this.getProperty;
    const funcs = ids.map(id => () => getProperty(id));
    if (!ids.length) {
      this.noFav = true;
    } else {
      promiseSerial(funcs);
    }
    // .then(console.log.bind(console));
  },
  methods: {
    getFav() {
      const favObj = _.pickBy(
        Object.keys(localStorage).reduce(function(obj, str) {
          obj[str] = localStorage.getItem(str);
          return obj;
        }, {}),
        (v, k) => {
          return k.startsWith(this.$getConst("FAV_PREFIX"));
        }
      );
      return Object.keys(favObj)
        .sort((a, b) => favObj[b] - favObj[a]) //newer to older
        .map(a => a.replace(this.$getConst("FAV_PREFIX"), ""));
    },
    getProperty(id) {
      return axios
        .get(`https://api.topagentmo.com/api/advertiseProperties/${id}`)
        .then(res => res.data)
        .then(d => {
          this.list.push(d);
          return d;
        })
        .catch(e => null);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  &.noFav {
    display: flex;
    justify-content: center;
    align-items: center;
    .noFavLine {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 6px;
        height: 1.5rem;
      }
    }
  }
  min-height: 80vh;
  max-width: 1820px;
  margin: 0 auto;
  padding: 16px 60px 30px;
  @media all and (max-width: 768px) {
    padding: 16px 4vw 30px;
  }

  > h3 {
    color: rgb(72, 72, 72);
    font-size: 24px;
    text-align: left;
  }
}
</style>
